import { SECTION as SECTION_FIELD } from "./";
import { ALL } from "../strings";

const DEFAULT_VALUE = {
  value: "0",
  label: ALL,
  functionParameters: { value: "0", label: ALL },
};

export const SECTION = {
  title: "Section",
  field: SECTION_FIELD,
  mapToValues: (sections) =>
    (sections || []).reduce((acc, { sectionCode, sectionName }) => {
      const value = {
        value: `${sectionCode}`,
        label: sectionName,
      };
      acc.push({
        ...value,
        functionParameters: value,
      });
      return acc;
    }, []),
  defaultValue: DEFAULT_VALUE,
  filterCallback: ({ driver, value }) => `${driver?.sectionCode}` === value,
  volumeOverlayRequired: false,
};
